/* eslint-disable @atlaskit/editor/no-re-export */
// Entry file in package.json

export var searchMatchClass = 'search-match';
export var searchMatchTextClass = 'search-match-text';
export var selectedSearchMatchClass = 'selected-search-match';
export var blockSearchMatchClass = 'search-match-block';
export var selectedBlockSearchMatchClass = 'search-match-block-selected';
export var darkModeSearchMatchClass = 'search-match-dark';
export var searchMatchExpandTitleClass = 'search-match-expand-title';